module.exports = __webpack_public_path__ + "img/about.4fc3ee8e.png";